<template>
	<div class="w-full mx-auto max-w-screen">
		<UPageCTA
			:title="$t('address-checker.cta')"
			variant="subtle"
			:ui="{
				root: 'bg-primary text-inverted w-full flex flex-col justify-center relative isolate overflow-hidden rounded-none ring-0',
				title: 'text-4xl sm:text-4xl tracking-tight font-bold text-inverted lg:whitespace-nowrap'
			}"
		>
			<template #links>
				<SignupAddressChecker
					:tracking-location="trackingLocation"
					button-variant="outline"
					button-color="neutral"
				/>
			</template>
		</UPageCTA>
	</div>
</template>

<script lang="ts" setup>
defineProps({
	trackingLocation: {
		type: String,
		required: true
	}
})
</script>
